import React from 'react';

const SimpleFooter = ({ footerLanguage }) => {
  // Destructure props
  return (
    <div className="bg-[#F9FAFB] border border-[#E5E7EB] p-4 print:hidden">
      <p className="text-sm font-normal text-black/50 text-center">{footerLanguage}</p>
    </div>
  );
};

export default SimpleFooter;
